import { render, staticRenderFns } from "./children.vue?vue&type=template&id=cd0e7b0a"
import script from "./children.vue?vue&type=script&lang=js"
export * from "./children.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mining-sale-cms-front/mining-sale-cms-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd0e7b0a')) {
      api.createRecord('cd0e7b0a', component.options)
    } else {
      api.reload('cd0e7b0a', component.options)
    }
    module.hot.accept("./children.vue?vue&type=template&id=cd0e7b0a", function () {
      api.rerender('cd0e7b0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/children.vue"
export default component.exports